// Mise en forme des dates du CV, à la manière de LinkedIn
// (lang = 'fr' par défaut, 'en' pour la version anglaise du CV)
const MONTHS = {
  fr: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
};

// "2023-09" → "sept. 2023" / "Sep 2023"
export function formatMonth(ym, lang = 'fr') {
  if (!ym) return '';
  const [y, m] = ym.split('-').map(Number);
  return `${(MONTHS[lang] || MONTHS.fr)[m - 1]} ${y}`;
}

const nowYm = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// Durée en mois, mois de début et de fin inclus (comme LinkedIn)
function monthsBetween(start, end) {
  const [y1, m1] = start.split('-').map(Number);
  const [y2, m2] = end.split('-').map(Number);
  return (y2 - y1) * 12 + (m2 - m1) + 1;
}

// 27 → "2 ans 3 mois" / "2 yrs 3 mos" (format LinkedIn)
export function formatDuration(months, lang = 'fr') {
  if (!months || months < 1) return '';
  const y = Math.floor(months / 12), m = months % 12;
  const parts = [];
  if (lang === 'en') {
    if (y) parts.push(`${y} yr${y > 1 ? 's' : ''}`);
    if (m) parts.push(`${m} mo${m > 1 ? 's' : ''}`);
  } else {
    if (y) parts.push(`${y} an${y > 1 ? 's' : ''}`);
    if (m) parts.push(`${m} mois`);
  }
  return parts.join(' ');
}

// "sept. 2023 - aujourd'hui · 2 ans 1 mois"
export function formatRange(start, end, current, withDuration = true, lang = 'fr') {
  if (!start && !end) return '';
  const left = formatMonth(start, lang);
  const right = current ? (lang === 'en' ? 'Present' : 'aujourd\'hui') : formatMonth(end, lang);
  let txt = left && right ? `${left} - ${right}` : (left || right);
  if (withDuration && start) {
    const d = formatDuration(monthsBetween(start, current || !end ? nowYm() : end), lang);
    if (d && (current || end)) txt += ` · ${d}`;
  }
  return txt;
}

// Pour trier du plus récent au plus ancien (postes en cours en premier)
export const byRecent = (startKey, endKey = 'end') => (a, b) => {
  const ea = a.current ? '9999-99' : (a[endKey] || a[startKey] || '');
  const eb = b.current ? '9999-99' : (b[endKey] || b[startKey] || '');
  if (ea !== eb) return eb.localeCompare(ea);
  return (b[startKey] || '').localeCompare(a[startKey] || '');
};

export const initials = (text) => (text || '?')
  .split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
